import { getQueryKeys } from "@/app/_module/services/helper";
import AgencyTokenManager from "@/app/_module/services/agencyTokenManager";

const namespace = "appointments";

// Memoized agency context to prevent infinite re-renders
let cachedAgencyContext: { agencyId: string | null } | null = null;
let lastAgencyId: string | null = null;

// Helper function to get current agency context for query keys
const getAgencyContext = () => {
  const agencyId = AgencyTokenManager.getCurrentAgencyId();
  
  // Only create new context if agency ID has changed
  if (agencyId !== lastAgencyId) {
    lastAgencyId = agencyId;
    cachedAgencyContext = agencyId ? { agencyId } : { agencyId: null };
  }
  
  return cachedAgencyContext!;
};

const appointmentQueryKeys = {
  ...getQueryKeys(namespace),

  // Custom function keys for appointments-specific functionality
  all: () => [namespace, getAgencyContext()] as const,
  lists: () => [namespace, "list", getAgencyContext()] as const,
  list: (filters: {
    page?: number;
    limit?: number;
    query?: string;
    status?: string;
    leadId?: string;  // Added for filtering by lead
  }) => [namespace, "list", filters, getAgencyContext()] as const,
  details: () => [namespace, "detail", getAgencyContext()] as const,
  detail: (id: string) => [namespace, "detail", id, getAgencyContext()] as const,
  stats: () => [namespace, "stats", getAgencyContext()] as const,
  byLead: (leadId: string) => [namespace, "byLead", leadId, getAgencyContext()] as const,
  today: (includeTomorrow?: boolean) => [namespace, "today", { includeTomorrow }, getAgencyContext()] as const,
};

export default appointmentQueryKeys;
